import { render, staticRenderFns } from "./PageDeleteAccount.vue?vue&type=template&id=312d5592&"
import script from "./PageDeleteAccount.vue?vue&type=script&lang=js&"
export * from "./PageDeleteAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports